export const resetStyleTooltips = {
    padding: 0,
    borderRadius: 12,
    backgroundColor: "none",
    borderColor: "none",
    borderStyle: "none",
    borderWidth: 0,
};
